import { object, string, number, boolean, nullable, InferOutput } from 'valibot';

// Define the schema for TinCan data response
export const TincanDataSchema = object({
  alwlaun: number(),
  component_id: number(),
  component_title: string(),
  content_href: string(),
  course_id: string(),
  credit_mode: boolean(),
  enroll_id: string(),
  h_scale: string(),
  identifier: string(),
  launch_scorm_in_new_window: boolean(),
  launcher_version: nullable(string()),
  lup_tincanData_id: number(),
  registration: string(),
  scorm_apiendpoint: string(),
  scorm_content_location: string(),
  scorm_popup_window_height: nullable(number()),
  scorm_popup_window_width: nullable(number()),
  scorm_token: string(),
  student_id: string(),
  student_name: string(),
  tindata_id: number(),
  v_scale: string(),
});

// Create a type from the schema
export type TincanData = InferOutput<typeof TincanDataSchema>;
